import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { fire, auth } from "../../firebase/index";
import { getDetailsAndUpdateDB } from "./MemberManagementHelper";
import { customLog } from "../../variables/Variables";

import { style } from "variables/Variables.jsx";
import NotificationSystem from "react-notification-system";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    addToRecipient: "Add to Recipient",
    adding: "Adding user...",
    existed: "User has already been added !",
    added: "has been added !",
    processing: "Processing...",
    superAdmin: "Super Admin",
    currentAccount: "Current Acccount",
  },
  ja: {
    addToRecipient: "追加",
    adding: "メンバー追加...",
    existed: "ユーザーはすでに追加されています。",
    added: "を追加しました。",
    processing: "処理中...",
    superAdmin: "",
    currentAccount: "",
  },
  es: {
    addToRecipient: "Agregar al Destinatario",
    adding: "Agregando usuario...",
    existed: "¡El usuario ya ha sido agregado!",
    added: "¡ha sido agregado!",
    processing: "Procesando...",
    superAdmin: "",
    currentAccount: "",
  },
});

class AddToRecipientButton extends Component {
  constructor(props) {
    super(props);

    this.addUserToRecipient = this.addUserToRecipient.bind(this);
    this.showNotification = this.showNotification.bind(this);

    this.state = {
      _notificationSystem: null,
      loading: false,
    };
  }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillMount() {
    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  showNotification(msg, lvl, cd) {
    const notification = this.state._notificationSystem;
    notification.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: cd,
    });
  }
  async addUserToRecipient() {
    this.setState({ loading: true });
    const data = this.props.data;
    // console.log(data);
    // this.showNotification(localizationStrings.adding, "warning", 1);
    await getDetailsAndUpdateDB(data.memberEmail, (res) => {
      if (res === false) {
        this.showNotification(localizationStrings.existed, "warning", 2);
        this.setState({ loading: false });
      } else {
        res["line"] = 20;
        customLog(res);
        this.showNotification(
          `${res.friendEmail} ${localizationStrings.added}`,
          "success",
          2
        );
        this.setState({ loading: false });
      }
    });
  }
  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />

        <Button
          disabled={
            this.props.data.isSuperAdmin ||
            this.props.data.memberEmail === auth.currentUser.email ||
            this.state.loading
          }
          onClick={this.addUserToRecipient}
        >
          {this.props.data.isSuperAdmin
            ? localizationStrings.superAdmin
            : this.props.data.memberEmail === auth.currentUser.email
            ? localizationStrings.currentAccount
            : this.state.loading
            ? localizationStrings.processing
            : localizationStrings.addToRecipient}
        </Button>
      </div>
    );
  }
}

export default AddToRecipientButton;
